import firstPlaceIcon from "../../../assets/icons/firstPlaceIcon.svg";
import secondPlaceIcon from "../../../assets/icons/secondPlaceIcon.svg";
import thirdPlaceIcon from "../../../assets/icons/thirdPlaceIcon.svg";

export const trophyIconsMap: Record<number, string> = {
  0: firstPlaceIcon,
  1: secondPlaceIcon,
  2: thirdPlaceIcon,
};
